import React, { useEffect, useState } from "react";
import axios from "axios";

function FestivalInformer() {
  const [festivals, setFestivals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/festival-informer/upcoming`)
      .then((res) => setFestivals(res.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-4 text-white">Upcoming Indian Festivals</h1>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <ul className="bg-white rounded shadow p-4 space-y-3">
          {festivals.length === 0 ? (
            <li>No upcoming festivals found.</li>
          ) : (
            festivals.map((fest) => (
              <li key={fest.name} className="flex justify-between">
                <span className="font-semibold">{fest.name}</span>
                <span>{new Date(fest.date).toLocaleDateString()}</span>
              </li>
            ))
          )}
        </ul>
      )}
      <div className="mt-4 text-gray-500 text-sm">
        Email reminders will be sent to all users 3 days before each festival.
      </div>
    </div>
  );
}

export default FestivalInformer;
